import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.widgets.context-panel`, {
  'query-builder.context-menu.automatically-tracked': `Automatically tracked by Mixpanel`,
  'query-builder.context-menu.codeless-tracking': `Tracked through Codeless tracking`,
  'query-builder.context-menu.cohort-edit': `Edit Cohort`,
  'query-builder.context-menu.cohort-id': `Cohort ID`,
  'query-builder.context-menu.cohort-save': `Save custom property to share`,
  'query-builder.context-menu.cohort-view': `View Cohort`,
  'query-builder.context-menu.creator': `Creator`,
  'query-builder.context-menu.description-add-placeholder': `Add Description...`,
  'query-builder.context-menu.description-placeholder': `Please add a description`,
  'query-builder.context-menu.edit-custom-event': `Edit Custom Event`,
  'query-builder.context-menu.edit-no-access': `You have view-only access and cannot edit`,
  'query-builder.context-menu.events-usage_one': `{{count, number}} event with this property in the last 30 days`,
  'query-builder.context-menu.events-usage_other': `{{count, number}} events with this property in the last 30 days`,
  'query-builder.context-menu.example': `Example`,
  'query-builder.context-menu.from-borrowed-property': `Borrowed from {{borrowedEventName}}`,
  'query-builder.context-menu.from-history-table': `Imported from history table`,
  'query-builder.context-menu.from-lookup-table': `From {{lookupTableName}}`,
  'query-builder.context-menu.lookup-table-info': `More about Lookup Tables`,
  'query-builder.context-menu.merged-event-description': `This event has been merged into {{mergedToEventName}} and is no longer tracked separately.`,
  'query-builder.context-menu.merged-event-name': `Merged to {{mergedToEventName}}`,
  'query-builder.context-menu.merged-property-description': `This property has been merged into {{mergedToPropertyName}} and is no longer tracked separately.`,
  'query-builder.context-menu.merged-property-name': `Merged to {{mergedToPropertyName}}`,
  'query-builder.context-menu.new': `New`,
  'query-builder.context-menu.no-data': `There is no associated data.`,
  'query-builder.context-menu.owner': `Owner`,
  'query-builder.context-menu.owner_plural': `Owners`,
  'query-builder.context-menu.platforms': `Platforms`,
  'query-builder.context-menu.property-edit': `Edit Property`,
  'query-builder.context-menu.property-is-local': `Local custom property, only visible in this report.`,
  'query-builder.context-menu.property-save': `Save custom property to share`,
  'query-builder.context-menu.query-count_one': `Queried {{count, number}} time in the last 30 days`,
  'query-builder.context-menu.query-count_other': `Queried {{count, number}} times in the last 30 days`,
  'query-builder.context-menu.query-rank': `#{{rank, number}} most queried event in your project`,
  'query-builder.context-menu.recently-used': `Recently used by you`,
  'query-builder.context-menu.report-backlinks_one': `{{count, number}} report`,
  'query-builder.context-menu.report-backlinks_other': `{{count, number}} reports`,
  'query-builder.context-menu.session-replay': `Recent Replay`,
  'query-builder.context-menu.share': `Share`,
  'query-builder.context-menu.share-no-access': `You have view-only access and cannot share`,
  'query-builder.context-menu.track-count_one': `Tracked this event {{count, number}} time in the last 30 days`,
  'query-builder.context-menu.track-count_other': `Tracked this event {{count, number}} times in the last 30 days`,
  'query-builder.context-menu.tracked-as': `Tracked as`,
  'query-builder.context-menu.unsaved-changes': `Metric in use is modified from original. To reset or push changes, use the overflow menu at the end of the row.`,
  'query-builder.context-menu.usage-count_one': `Used by {{count, number}} teammate in the last 30 days`,
  'query-builder.context-menu.usage-count_other': `Used by {{count, number}} teammates in the last 30 days`,
  'query-builder.context-menu.usage-times_one': `Used by teammates {{count, number}} time in the last 30 days`,
  'query-builder.context-menu.usage-times_other': `Used by teammates {{count, number}} times in the last 30 days`,
  'query-builder.context-menu.used-in-reports': `Used in`,
  'query-builder.context-menu.user-query-scd-notice': `For user queries, the latest value will be used.`,
  'query-builder.context-menu.users-usage_one': `{{count, number}} user with this property in the last 30 days`,
  'query-builder.context-menu.users-usage_other': `{{count, number}} users with this property in the last 30 days`,
  'query-builder.context-menu.verified-by': `Verified by`,
  'query-builder.context-menu.verified-tooltip': `Verified on {{date}} by {{name}}`,
  'query-builder.context-menu.view-in-lexicon': `View in Lexicon`,
  'query-builder.context-menu.view-in-users': `View on Users Page`,
  'query-builder.context-menu.view-sample-events': `View Sample Events`,
});
